const index = () => import('./pages/index')

export default [
  {
    path: '/assignments',
    name: 'assignments.index',
    component: index,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/assignments/routes.js